import { useCallback, useState } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

// constants
import { ROUTES } from "./constants";

// pages
import LoginPage from "./pages/login";
import StaffSelectPage from "./pages/staff-select";
import HomePage from "./pages/home";
import PatientCreatePage from "./pages/patient-create";
import PatientSearchPage from "./pages/patient-search";
import ImageCapturePage from "./pages/image-capture";
import ScrollToTop from "./components/scroll-to-top";

function App() {

  const [isUserLoggedIn, setIsUserLoggedIn] = useState(() => {
    const accessToken = localStorage.getItem("access_token");
    const tokenExpireTime = localStorage.getItem("expires_at");

    if (
      !accessToken ||
      tokenExpireTime < new Date().getTime()
    ) {
      localStorage.removeItem('access_token');
      localStorage.removeItem('expires_at');
      return false;
    }

    return true;
  }, [])

  const [isStaffSelected, setIsStaffSelected] = useState(() => {
    return Boolean(localStorage.getItem("staffId"));
  })

  const getAuthenticatedRoute = useCallback((component, skipStaffCheck = false) => {
    if (!isUserLoggedIn) return <Navigate to={ROUTES.LOGIN} />;

    if (!skipStaffCheck && !isStaffSelected) {
      return <Navigate to={ROUTES.STAFF_SELECT} />;
    }

    return component
  }, [isUserLoggedIn, isStaffSelected])

  return (
    <main className="min-h-screen relative flex flex-col bg-background-1 text-text-1 font-gray-400 h-full tracking-wide">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path={ROUTES.LOGIN} element={isUserLoggedIn ? <Navigate to={ROUTES.HOME} /> : <LoginPage onLogin={() => { setIsUserLoggedIn(true); setIsStaffSelected(false); }} />} />
          <Route path={ROUTES.STAFF_SELECT} element={getAuthenticatedRoute(<StaffSelectPage onStaffSelect={() => setIsStaffSelected(true)} />, true)} />
          <Route path={ROUTES.HOME} element={getAuthenticatedRoute(<HomePage />)} />
          <Route path={ROUTES.PATIENT_CREATE} element={getAuthenticatedRoute(<PatientCreatePage />)} />
          <Route path={ROUTES.PATIENT_SEARCH} element={getAuthenticatedRoute(<PatientSearchPage />)} />
          <Route path={ROUTES.IMAGE_CAPTURE.STATIC} element={getAuthenticatedRoute(<ImageCapturePage />)} />
          <Route path="*" element={<Navigate to={'/'} />} />
        </Routes>
      </BrowserRouter>
    </main>
  );
}

export default App;
